import { Outlet } from "react-router-dom";

export default function LegalPagesLayout() {
    return (
        <>
            <Outlet />
        </>
    );
}